import Axios, { AxiosRequestConfig } from 'axios';

import { Label } from './types';

type Response = {
  readonly labels: Label[];
};

export default (config?: AxiosRequestConfig) => {
  return Axios.get<Response>(
    'https://statics.youtopin.com/json/labels.json',
    config
  );
};
